// removed by extract-text-webpack-plugin
module.exports = {"formSection":"znO9","appStoreButtons":"_23q4","svg":"_3Anv"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/NumbersEdit/NumbersEdit.scss
// module id = /BeZ
// module chunks = 0